import React from "react";
import G2 from "@antv/g2";
//import { Chart } from 'primereact/components/chart/Chart';
// import ChartJSLabel from "chartjs-plugin-datalabels";
import { Bar } from "react-chartjs-2";
import { VerticalMiddleContainer } from "../layout/Layout";
import { path, equals } from "ramda";
import DataSet from "@antv/data-set";
import { isFunction, ArrayUtil } from "../../util";
import { DataVisualizeKeys } from "../../theme/Colors";
import ColorUtil from "../../util/ColorUtil";
import { withTheme } from "styled-components";
import { Metrics } from "../../theme";

class ColumnChart extends React.Component {
    _lastData = [];
    mutateData = {};
    chart = null;
    constructor(props){
    	super(props);
    	this.createData(props);
    }
    componentWillReceiveProps(props){
    	this.createData(props);
    }
    createData(props){
    	const { chart_id, 
    		data, 
    		labelKey, valueKey,
    		onClick,
    		theme,
    		visualColorKey,
    		hideZero,
    		orderColor,
    	} = props;
    	const labels = [];
    	const values = [];
    	const borderWidths = [];
    	const datasets = {
    		labels:[],
    	};
    	const colors = orderColor ? ColorUtil.generateVisualColorOfSize(theme, visualColorKey, data.length) : 
    		ColorUtil.getVisualizeColor(theme, visualColorKey, 0);
    	data.forEach((e,i)=>{
    		if(hideZero){
    			if(e[valueKey]>0){
    				labels.push(e[labelKey]);
    				values.push(e[valueKey]);
    				borderWidths.push(0);
    			}
    		}else{
    			labels.push(e[labelKey]);
    			values.push(e[valueKey]);
    			borderWidths.push(0);
    		}
    	});
    	this.mutateData = {
    		sum: values.length > 0 ? values.reduce((c,v)=>c+v) : 1,
    		labels,
    		datasets:[{
    			data:values,
    			borderWidth:borderWidths,
    			backgroundColor:colors
    		}]
    	};
    	this._lastData = data;
    }
    onItemClick = (e, active)=>{
    	if(ArrayUtil.isAliveArray(active, true)){
    		const { data, onClick } = this.props;
    		const { _index } = active[0];
    		if(isFunction(onClick)){
    			setTimeout(() => {
    				onClick(Object.values(data)[_index]);
    			}, Metrics.chart.onClickDelay);
    		}
    	}
    }
    shouldComponentUpdate(nextProps, nextState){
    	return !equals(this._lastData, nextProps.data);
    }
    render(){
    	const { chart_id, 
    		data, 
    		labelKey, 
    		valueKey, 
    		onClick,
    		theme,
    		showLegend = false,
    		tickInterval,
    		visualColorKey = DataVisualizeKeys.Primary,
    		lowestDisplayPercent, labelFontSize, showLabel
    	} = this.props;
    	return <VerticalMiddleContainer style={{paddingTop:10, paddingBottom:10}}>
    		<Bar 
    			ref={(ref)=>{this.chart=ref;}} 
    			data={this.mutateData} 
    			options={{
    				responsive:true,
    				animation:{
    					duration:Metrics.chart.duration
    				},
    				tooltips:false,
    				maintainAspectRatio:false,
    				onClick:this.onItemClick,
    				legend:{
    					display:false
    				},
    				plugins: {
    					datalabels: {
    						display: false,
    					}
				    },
    				scales: {
    					yAxes: [{
    						ticks: {
    							stepSize:tickInterval
    						}
    					}]
    				}
    			}}/>
    	</VerticalMiddleContainer>;
    }
}
ColumnChart.defaultProps = {
	data:[{year:"1234",sales:400}],
	labelKey:"year",
	valueKey:"sales",
	onClick:(item)=>{},
	hideZero: false,
	tickInterval:10,
	showLabel: true,
	orderColor: true,
	labelFontSize: Metrics.fontSize.bold,
	lowestDisplayPercent: 10
};
export default withTheme(ColumnChart);


// WEBPACK FOOTER //
// ./src/components/chart/ColumnChart.js